import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { base64ToFile } from 'ngx-image-cropper';
import { ResourceSerializer } from '../../share-components/rest-resource.interface';
import { RestResourceService } from '../../share-components/rest-resource.service';

@Injectable({
  providedIn: 'root'
})
export class AgentService extends RestResourceService {
  constructor(private http: HttpClient) {
    super(http, '/MembersPhotoApi/api/Agent', new AgentInfoSerializer());
  }
 

  public loadData(): Observable<any> {
    return this.http.get<AgentInfo>('/MembersPhotoAPI/api/Agent/GetAgentInfo');

  }

  public AddPhoto(fileBase64: any): Observable<any> {
    let fileToUpload = base64ToFile(fileBase64);
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileBase64.name);
    return this.http.post('/MembersPhotoAPI/api/Agent/AddPhoto', formData).pipe(map(() => { return true; }));

  }
  public AddLogo(fileBase64: any): Observable<any> {
    let fileToUpload = base64ToFile(fileBase64);
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileBase64.name);
    return this.http.post('/MembersPhotoAPI/api/Agent/AddLogo', formData).pipe(map(() => { return true; }));

  }

  public DeleteAgentLogo(): Observable<any> {
    return this.http.get('/MembersPhotoAPI/api/Agent/DeleteLogo').pipe(map(() => { return true; }));
  }
  public DeleteAgentPhoto(): Observable<any> {
    return this.http.get('/MembersPhotoAPI/api/Agent/DeletePhoto').pipe(map(() => { return true; }));
  }
}

export class AgentPhotoInfo {
  constructor(json: any = null) {
    if (json != null) {
      this.PhotoExists = json.PhotoExists;
      this.LogoExists = json.LogoExists;
    }
  }
  PhotoExists: boolean;
  LogoExists: boolean;
 
}
export class AgentInfo {
  constructor(json: any = null) {
    if (json != null) {
      this.Name = json.Name;
      this.Username = json.Username;
      this.Phone = json.Phone;
      this.Email = json.Email;
      this.Photo = json.Photo;
      this.Logo = json.Logo;
      this.Class = json.Class;
      this.MlsId = json.MlsId;
      this.FirmId = json.FirmId;
      this.AccessType = json.AccessType;
      this.OfficeName = json.OfficeName;
      this.PhotoInfo = new AgentPhotoInfo(json.AgentPhotoInfo);
      this.IncompleteCount = json.IncompleteCount;
      this.SoldCount = json.SoldCount;
      this.ExpiredCount = json.ExpiredCount;
      this.ActivePendingCount = json.ActivePendingCount;
      this.ComingSoonCount = json.ComingSoonCount;
      this.MlsExclusiveCount = json.MlsExclusiveCount;
      this.Mobile = json.Mobile;
    }
  }
  Name: string;
  Username: string;
  Phone: string;
  Email: string;
  Photo: string;
  Class: string;
  MlsId: string;
  FirmId: string;
  Logo: string;
  AccessType: number;
  OfficeName: string;
  Mobile: string;
  IncompleteCount: number;
  SoldCount: number;
  ExpiredCount: number;
  ComingSoonCount: number;
  MlsExclusiveCount: number
  ActivePendingCount: number;
  PhotoInfo: AgentPhotoInfo;
}
export class AgentInfoSerializer implements ResourceSerializer {
  fromJson(json) {
    let obj = new AgentInfo(json);
    return obj;
  }

  toJson(resource) { return resource; }
}

